/**
 * Nuxt DevTools overlay registers as the first Vue app, so Pinia's devtools
 * plugin may attach to it instead of the main app — Pinia tab stays empty.
 * @see https://github.com/nuxt/devtools/issues/724
 */
export default defineNuxtPlugin({
  name: 'devtools-app-record-fix',
  enforce: 'post',
  setup(nuxtApp) {
    if (!import.meta.dev) {
      return;
    }

    nuxtApp.hook('app:mounted', async () => {
      try {
        const {
          setActiveAppRecord,
          setActiveAppRecordId,
          registerDevToolsPlugin,
          devtoolsAppRecords,
        } = await import('@vue/devtools-kit');

        const records = devtoolsAppRecords.value;

        if (!Array.isArray(records) || records.length <= 1) {
          return;
        }

        const appRecord = records.find(r => r.app === nuxtApp.vueApp);

        if (!appRecord) {
          return;
        }

        setActiveAppRecord(appRecord);
        setActiveAppRecordId(appRecord.id);
        registerDevToolsPlugin(nuxtApp.vueApp);
      } catch {
        // @vue/devtools-kit may be unavailable outside dev
      }
    });
  },
});
